import React from 'react';
import IPhotos from '../../models/IPhoto';
import Guid from '../../models/Guid';

const guidEquals = (a: Guid | string | undefined, b: Guid | string | undefined): boolean => {
  if (a == null || b == null) return false;
  return a.toString() === b.toString();
};

interface IGestionRoulottteRenderPhoto {
  listePhoto: IPhotos[],
  idPhotoSelected: Guid,
  setSelectedPhoto: (idPhoto: Guid) => void,
  type: string,
  imageWidth?: string | number,
  imageHeight?: string | number
}

const GestionRoulottteRenderPhoto: React.FC<IGestionRoulottteRenderPhoto> = ({ listePhoto, idPhotoSelected, setSelectedPhoto, type, imageWidth, imageHeight }) => {

  return (
    <div>
      <div className="gestion-roulotte-photo-grid">
        {listePhoto.filter((photo: IPhotos) => photo.typeAuxiliaire === type).map((photo: IPhotos) => (
          <div
            key={photo.idPhoto.toString()}
            className={`gestion-roulotte-photo-item  ${guidEquals(idPhotoSelected, photo.idPhoto) ? 'gestion-roulotte-photo-item-selected' : ''}`}
            onClick={() => setSelectedPhoto(photo.idPhoto instanceof Guid ? photo.idPhoto : new Guid(photo.idPhoto))}>
            <img 
              src={`data:image/jpeg;base64,${photo.photoBytes || (photo as { base64?: string }).base64 || ''}`} 
              alt="Photo" 
              style={{
                width: imageWidth || 'auto',
                height: imageHeight || 'auto',
                objectFit: 'cover'
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GestionRoulottteRenderPhoto;
